import { useState } from 'react';
import Btn from '../../../components/btn/btn';
import ModalCenter from '../../../components/modal/modalCenter';

function ModalMisReclamo({reclamo}) {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);

  return (
    <>
      <Btn
        text="VER MÁS"
        action={handleShow}
        color="info"
      />

        <ModalCenter show={show} setShow={setShow} title={`Reclamo de ${reclamo?.DsServicio}`}>
            <p><strong>Titular: </strong>{reclamo?.Nombre}</p>
            <p><strong>Domicilio: </strong>{reclamo?.Domicilio}</p>
            <p><strong>Tipo de Falla: </strong>{reclamo?.DsTipoFallaDec}</p>
            <p><strong>Estado: </strong>{reclamo?.DsTipoEstTr}</p>
            {reclamo?.ObsDec && <p><strong>Observación: </strong>{reclamo?.ObsDec}</p>}
        </ModalCenter>

    </>
  );
}

export default ModalMisReclamo;